import Transfer from './src/index.vue'

Transfer.install = (Vue) => {
  Vue.component(Transfer.name, Transfer)
}

export default Transfer
